import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Box, Button, Grid, MenuItem, Stack, TextField } from '@mui/material';

import { LabeledField } from '@/__core/components/LabeledField';

import { InventoryStocktakeFormData } from '../types';

interface StocktakeFormProps {
  formData: InventoryStocktakeFormData;
  companyDisabled: boolean;
  companyOptions: Array<{ company_id: string; company_name: string }>;
  statusOptions: Array<{ id: string; name: string }>;
  onChangeForm: (updates: Partial<InventoryStocktakeFormData>) => void;
  onSave: () => void;
}

export default function StocktakeForm({
  formData,
  companyDisabled,
  companyOptions,
  statusOptions,
  onChangeForm,
  onSave,
}: StocktakeFormProps) {
  return (
    <Stack spacing={4} sx={{ pt: 1, pb: 3 }}>
      <Grid container rowSpacing={0} columnSpacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabeledField label='Mã kiểm kê' labelWidth={120}>
            <TextField size='small' value={formData.code} onChange={(event) => onChangeForm({ code: event.target.value })} fullWidth />
          </LabeledField>
          <LabeledField label='Tên phiếu kiểm kê' labelWidth={120}>
            <TextField size='small' value={formData.name} onChange={(event) => onChangeForm({ name: event.target.value })} fullWidth />
          </LabeledField>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabeledField label='Kho' labelWidth={120}>
            <TextField size='small' value={formData.store_name} onChange={(event) => onChangeForm({ store_name: event.target.value })} fullWidth />
          </LabeledField>
          <LabeledField label='Trạng thái' labelWidth={120}>
            <TextField select size='small' value={formData.status} onChange={(event) => onChangeForm({ status: event.target.value })} fullWidth>
              {statusOptions.filter((option) => option.id !== 'all').map((option) => (
                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
              ))}
            </TextField>
          </LabeledField>
          <LabeledField label='Ngày' labelWidth={120}>
            <TextField type='date' size='small' value={formData.date} onChange={(event) => onChangeForm({ date: event.target.value })} fullWidth />
          </LabeledField>
        </Grid>
      </Grid>

      <LabeledField label='Công ty' labelWidth={120}>
        <TextField select size='small' value={formData.company_id} onChange={(event) => onChangeForm({ company_id: event.target.value })} disabled={companyDisabled} fullWidth>
          {companyOptions.map((company) => (
            <MenuItem key={company.company_id} value={company.company_id}>{company.company_name}</MenuItem>
          ))}
        </TextField>
      </LabeledField>

      <LabeledField label='Ghi chú' labelWidth={120} multiline fieldAlign='start'>
        <Box>
          <TextareaAutosize
            minRows={4}
            value={formData.note}
            onChange={(event) => onChangeForm({ note: event.target.value })}
            placeholder='Nhập ghi chú cho phiếu kiểm kê...'
            style={{
              width: '100%',
              borderRadius: '6px',
              border: '1px solid #cbd5e1',
              padding: '16px 18px',
              fontSize: '0.95rem',
              lineHeight: 1.6,
              resize: 'vertical',
              outline: 'none',
              fontFamily: 'inherit',
              backgroundColor: '#fff',
            }}
          />
        </Box>
      </LabeledField>

      <Box sx={{ pt: 4, width: '100%' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='flex-end' spacing={2}>
          <Button variant='contained' onClick={onSave}>Lưu kiểm kê</Button>
        </Stack>
      </Box>
    </Stack>
  );
}